import { RootState } from 'typesafe-actions';
import { createSelector } from 'reselect';
import { KAMELEOON_COOKIE_KEY } from 'utils/kameleoon/cookie';

export const getAllCookies = (state: RootState) => state.cookieParsed?.cookies || {};

export const getIsAuthorized = createSelector(getAllCookies, (cookie) => {
  return cookie['user-auth'] === 'true';
});

export const getIsMonetizationStretchBanner = createSelector(
  getAllCookies,
  (cookies) => cookies?.monetization_plp_pdp_srp_top_banner === 'true',
);

export const getKameleoonVisitorCode = createSelector(getAllCookies, (cookies) => {
  return cookies?.[KAMELEOON_COOKIE_KEY];
});
